import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  DomSanitizer,
  SafeHtml,
  SafeResourceUrl,
} from '@angular/platform-browser';

@Component({
  selector: 'smart-fix-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
})
export class VideoPlayerComponent implements OnInit {
  @Input() videoUrl!: string | undefined;
  @Input() description!: string | undefined;
  @Input() offset: number = 0;
  @Input() closed = false;
  @Output() watchedVideo: EventEmitter<boolean> = new EventEmitter();
  safeVideoUrl!: SafeResourceUrl;
  safeDescription!: SafeHtml;

  constructor(private domSanitizer: DomSanitizer) {}

  ngOnInit() {
    if (this.videoUrl) {
      // Extract video ID and timestamp
      const videoIdMatch = this.videoUrl.match(
        /(?:v=|\/)([a-zA-Z0-9_-]{11})(?:[&?]t=(\d+))?/
      );

      if (videoIdMatch) {
        const videoId = videoIdMatch[1];
        const timestamp = videoIdMatch[2] || this.offset;

        const embedUrl = `https://www.youtube.com/embed/${videoId}?start=${timestamp}`;
        this.safeVideoUrl =
          this.domSanitizer.bypassSecurityTrustResourceUrl(embedUrl);
      }
    }

    if (this.description) {
      this.safeDescription = this.domSanitizer.bypassSecurityTrustHtml(
        this.description
      );
    }
  }

  submitVideoWatched() {
    this.watchedVideo.emit(true);
  }
}
